import { useState, useEffect } from 'react';
import AssignmentService from '../services/AssignmentService';

/**
 * Custom hook to fetch assignments for a video
 * 
 * @param {string} videoId - The ID of the video to fetch assignments for
 * @returns {Object} - The assignments, loading state, and refresh function
 */
export const useAssignments = (videoId) => {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Define the fetch function outside useEffect so we can call it from refresh
  const fetchAssignments = async () => {
    if (!videoId) return;
    
    try {
      setLoading(true);
      const authUser = JSON.parse(localStorage.getItem('authUser'));
      const authToken = JSON.parse(localStorage.getItem('authToken'));
      
      const response = await AssignmentService.getAssignmentsForVideo(
        videoId, 
        authUser.email, 
        authToken
      );
      
      if (response && response.data) {
        setAssignments(response.data);
      }
    } catch (err) {
      console.error("Error fetching assignments:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // The refresh function to reload assignments
  const refresh = () => {
    console.log('Refreshing assignments for video ID:', videoId);
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    fetchAssignments();
  }, [videoId, refreshTrigger]); // Depend on refreshTrigger to re-fetch

  return { 
    assignments, 
    loading, 
    error, 
    refresh  // Make sure this is included in the return object
  };
};